(function(angular){
	'use strict';
	
	var progressIndicatorObject = {
		templateUrl: ['STATIC_BASE_PATH', templateUrlFunction],
		bindings: {
			activeIndex: '@',
			steps: '<'
		},
		controller: [
			ProgressIndicatorFunction
		],
		controllerAs: 'progressIndicator'
	};
	
	angular
		.module('progressIndicatorModule')
		.component('progressIndicator', progressIndicatorObject);
	
	function templateUrlFunction(STATIC_BASE_PATH){
		return STATIC_BASE_PATH + '/static/html/shared/progress-indicator/progress-indicator.html';
	}
	
	function ProgressIndicatorFunction(){
		var progressIndicator = this;

		progressIndicator.$onInit = function() {
			var length = progressIndicator.steps.length;
			progressIndicator.columnWidth = length === 5 ? 2 : 12 / length;
		};
	}
})(window.angular);